<template>
  <v-main>
    <v-container fluid class="grey lighten-4">
      <v-container fluid class="pa-xs-0 pa-sm-0 pa-md-0 pa-lg-10">
        <v-row align="start" justify="center">
          <v-col xs="12" sm="12" md="7" lg="7" xl="7">
            <p
              class="text-xs-center text-sm-center text-md-start text-lg-start text-h4 font-weight-semibold"
            >
              Search Forum Topic
            </p>
          </v-col>
        </v-row>
        <v-row align="start" justify="center" wrap class="mt-n4">
          <v-col xs="12" sm="12" md="6" lg="6" xl="6">
            <v-text-field
              v-model="search"
              outlined
              class="rounded-lg"
              solo
              prepend-inner-icon="mdi-magnify"
              full-width
            />
          </v-col>
          <v-col
            xs="12"
            sm="12"
            md="1"
            lg="1"
            xl="1"
            :class="{
              'mt-n10': $vuetify.breakpoint.smAndDown,
              'my-3': $vuetify.breakpoint.smAndDown
            }"
          >
            <v-btn
              color="primary"
              dark
              depressed
              width="100"
              height="55"
              :block="$vuetify.breakpoint.smAndDown"
              >Search</v-btn
            >
          </v-col>
        </v-row>
      </v-container>

      <v-container class="pa-2">
        <v-container fluid class="rounded-lg pa-2 white">
          <v-row align="start" justify="center">
            <v-col cols="12">
              <div
                class="d-flex flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-row-xl align-xs-center align-sm-center align-lg-start justify-xs-center justify-sm-center justify-md-center justify-lg-start ma-lg-5 ma-sm-0 ma-xs-0"
              >
                <v-btn-toggle v-model="selectedFilter" group color="primary">
                  <v-btn
                    v-for="filter in filters"
                    :key="filter"
                    :value="filter"
                    class="rounded-lg"
                    x-large
                    >{{ filter }}</v-btn
                  >
                </v-btn-toggle>
                <span style="width: 250px; margin: 0">
                  <v-select
                    class="rounded-lg"
                    dark
                    solo
                    flat
                    clearable
                    full-width
                    background-color="primary"
                    v-model="selectedCategory"
                    :items="categories"
                  />
                </span>
              </div>
              <hr class="grey lighten-4" />
            </v-col>
            <v-col cols="11" v-if="forumLoading">
              <v-skeleton-loader
                v-bind="skeletonClass"
                type="card, article"
                class="my-6"
              ></v-skeleton-loader>
            </v-col>
            <v-col cols="11" v-if="search && !topicDisplay.length">
              <p class="text-center text-h6 primary--text font-weight-semibold">
                There is no topic/s related to your search...
              </p>
            </v-col>
            <v-col cols="11" v-for="topic in topicDisplay" :key="topic.id">
              <ForumEntry
                :id="topic.id"
                :title="topic.title"
                :date="topic.date"
                :categories="topic.categories"
                :image="topic.image"
                :comments="topic.comments"
                :body="topic.body"
                class="my-3"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </v-container>
  </v-main>
</template>

<script>
import ForumEntry from '@/components/Forum/ForumEntry.vue'
import { ANALYTICS } from '@/configs/firebase'
import { logEvent } from 'firebase/analytics'
export default {
  name: 'Forum',
  components: { ForumEntry },
  async created() {
    this.forumLoading = true
    const topics = this.$store.getters['cms/TOPICS']
    if (!topics.length) {
      await this.$store.dispatch('cms/POPULATE_FORUMS')
    }
    logEvent(ANALYTICS, 'visited_forum')
    this.forumLoading = false
  },
  data: () => ({
    search: '',
    filters: ['Top', 'New', 'FAQs'],
    selectedFilter: 'New',
    selectedCategory: '',
    skeletonClass: {
      boilerplate: true,
      elevation: 2
    },
    forumLoading: false
  }),
  computed: {
    topics() {
      return this.$store.getters['cms/TOPICS']
    },
    categories() {
      return this.$store.getters['cms/CATEGORIES']
    },
    filteredTopics() {
      const topicCopy = [...this.topics]
      if (this.selectedFilter && this.selectedFilter.toLowerCase() === 'top') {
        return topicCopy.sort((prev, next) => next.comments - prev.comments)
      }

      if (this.selectedFilter && this.selectedFilter.toLowerCase() === 'new') {
        return topicCopy.sort((prev, next) => prev.date - next.date)
      }

      return topicCopy
    },
    categoricalTopics() {
      const topicCopy = [...this.filteredTopics]

      if (this.selectedCategory && this.selectedCategory.length) {
        return topicCopy.filter((t) =>
          t.categories
            .map((c) => c.toLowerCase())
            .includes(this.selectedCategory.toLowerCase())
        )
      }

      return topicCopy
    },
    topicsBySearch() {
      const topicCopy = [...this.categoricalTopics]
      if (this.search) {
        return topicCopy.filter(
          (t) =>
            t.title.toLowerCase().includes(this.search.toLowerCase()) ||
            t.body.toLowerCase().includes(this.search.toLowerCase())
        )
      }

      return topicCopy
    },
    topicDisplay() {
      return this.topicsBySearch
    }
  }
}
</script>

<style></style>
